export const currencies = [
  { name: "Nigerian Naira" },
  { name: "United States Dollar" },
  { name: "Euro" },
  { name: "Japanese Yen" },
  { name: "British Pound Sterling" },
  { name: "Australian Dollar" },
  { name: "Canadian Dollar" },
  { name: "Swiss Franc" },
  { name: "Chinese Yuan" },
  { name: "Swedish Krona" },
  { name: "New Zealand Dollar" },
  { name: "Mexican Peso" },
  { name: "Singapore Dollar" },
  { name: "Hong Kong Dollar" },
  { name: "Norwegian Krone" },
  { name: "South Korean Won" },
  { name: "Turkish Lira" },
  { name: "Russian Ruble" },
  { name: "Indian Rupee" },
  { name: "Brazilian Real" },
  { name: "South African Rand" },
  { name: "Danish Krone" },
  { name: "Polish Zloty" },
  { name: "New Taiwan Dollar" },
  { name: "Thai Baht" },
  { name: "Malaysian Ringgit" },
  { name: "Indonesian Rupiah" },
  { name: "Czech Koruna" },
  { name: "Hungarian Forint" },
  { name: "Israeli New Shekel" },
  { name: "Chilean Peso" },
  { name: "Philippine Peso" },
  { name: "United Arab Emirates Dirham" },
  { name: "Colombian Peso" },
  { name: "Saudi Riyal" },
  { name: "Romanian Leu" },
  { name: "Egyptian Pound" },
  { name: "Bangladeshi Taka" },
  { name: "Pakistani Rupee" },
  { name: "Vietnamese Dong" },

  { name: "Kuwaiti Dinar" },
  { name: "Qatari Riyal" },
  { name: "Moroccan Dirham" },
  { name: "Ukrainian Hryvnia" },
  { name: "Kenyan Shilling" },
  { name: "Ghanaian Cedi" },
  { name: "Algerian Dinar" },
  { name: "Sri Lankan Rupee" },
  { name: "Jordanian Dinar" },
  { name: "Omani Rial" },
  { name: "Bahraini Dinar" },
  { name: "Lebanese Pound" },
  { name: "Tunisian Dinar" },
  { name: "Iraqi Dinar" },
  { name: "Dominican Peso" },
  { name: "Peruvian Sol" },
  { name: "Argentine Peso" },
  { name: "Uruguayan Peso" },
  { name: "Bolivian Boliviano" },
  { name: "Paraguayan Guarani" },
  { name: "Venezuelan Bolívar" },
  { name: "Costa Rican Colón" },
  { name: "Guatemalan Quetzal" },
  { name: "Honduran Lempira" },
  { name: "Nicaraguan Córdoba" },
  { name: "Belize Dollar" },
  { name: "Jamaican Dollar" },
  { name: "Trinidad and Tobago Dollar" },
  { name: "East Caribbean Dollar" },
  { name: "Bahamian Dollar" },
  { name: "Barbadian Dollar" },
  { name: "Cayman Islands Dollar" },
  { name: "Surinamese Dollar" },
  { name: "Netherlands Antillean Guilder" },
  { name: "Aruban Florin" },
  { name: "Bermudian Dollar" },
  { name: "Fijian Dollar" },
  { name: "Papua New Guinean Kina" },
  { name: "Solomon Islands Dollar" },
  { name: "Tongan Paʻanga" },
  { name: "Samoan Tala" },
  { name: "Vanuatu Vatu" },
  { name: "CFP Franc" },
  { name: "West African CFA Franc" },
  { name: "Central African CFA Franc" },
  { name: "Malagasy Ariary" },
  { name: "Mauritian Rupee" },
  { name: "Seychellois Rupee" },
  { name: "Maldivian Rufiyaa" },
  { name: "Nepalese Rupee" },
  { name: "Bhutanese Ngultrum" },
  { name: "Macanese Pataca" },
  { name: "Lao Kip" },
  { name: "Burmese Kyat" },
  { name: "Kazakhstani Tenge" },
  { name: "Uzbekistani Soʻm" },
  { name: "Tajikistani Somoni" },
  { name: "Kyrgyzstani Som" },
  { name: "Afghan Afghani" },
  { name: "Mongolian Tögrög" },
  { name: "Iranian Rial" },
  { name: "Syrian Pound" },
  { name: "Yemeni Rial" },
  { name: "Sudanese Pound" },
  { name: "Somali Shilling" },
  { name: "Tanzanian Shilling" },
  { name: "Ugandan Shilling" },
  { name: "Rwandan Franc" },
  { name: "Burundian Franc" },
  { name: "Malawian Kwacha" },
  { name: "Zambian Kwacha" },
  { name: "Mozambican Metical" },
  { name: "Swazi Lilangeni" },
  { name: "Lesotho Loti" },
  { name: "Botswana Pula" },
  { name: "Namibian Dollar" },
  { name: "Angolan Kwanza" },
  { name: "Guinean Franc" },
  { name: "Sierra Leonean Leone" },
  { name: "Gambian Dalasi" },
  { name: "Mauritanian Ouguiya" },
  { name: "Cape Verdean Escudo" },
  { name: "São Tomé and Príncipe Dobra" },
  { name: "Djiboutian Franc" },
  { name: "Comorian Franc" },
  { name: "Ethiopian Birr" },
  { name: "Eritrean Nakfa" },
  { name: "Somali Shilling" },
  { name: "Swazi Lilangeni" },
  { name: "Zimbabwean Dollar" },
];

export const crossReviewTypeFormatter = (key) => {
  switch (key) {
    case 1:
      return "Horizontal";
    case 2:
      return "Vertical";
    default:
      return "";
  }
};

export const appraisalPeriodFormatter = (key) => {
  switch (key) {
    case 1:
      return "Daily";
    case 2:
      return "Weekly";
    case 3:
      return "Monthly";
    case 4:
      return "Quarterly";
    case 5:
      return "BiAnnual";
    case 6:
      return "Yearly";
    default:
      return "";
  }
};
export const MeasurementTypeFormatter = (key) => {
  switch (key) {
    case 1:
      return "Number";
    case 2:
      return "Currency";
    case 3:
      return "Percentage";
    case 4:
      return "Rating";
    case 5:
      return "YesNo";
    default:
      return "";
  }
};
export const appraisalPeriod = [
  {
    filter: 1,
    name: "Daily",
  },
  {
    filter: 2,
    name: "Weekly",
  },
  {
    filter: 3,
    name: "Monthly",
  },
  {
    filter: 4,
    name: "Quarterly",
  },
  {
    filter: 5,
    name: "BiAnnual",
  },
  {
    filter: 6,
    name: "Yearly",
  },
];

export const MeasurementType = [
  {
    id: 0,
    name: "Select Type",
  },
  {
    id: 1,
    name: "Number",
  },
  {
    id: 2,
    name: "Currency",
  },
  {
    id: 3,
    name: "Percentage",
  },
  {
    id: 4,
    name: "Rating",
  },
  {
    id: 5,
    name: "Yes/No",
  },
];

export const crossReviewType = [
  {
    id: 1,
    name: "Horizontal",
  },
  {
    id: 2,
    name: "Vertical",
  },
];
